<template>
  <div>
    <Header />
    <section
      id="inventory"
      class="pt-2 pb-5 text-white"
      style="background-image:url(/assets/images/bg/aggregator-bg.jpg); background-position: center center; background-size:cover; background-repeat: no-repeat"
    >
      <h3 class="text-center">Aggregator</h3>
      <p class="w-50 mx-auto text-center font-weight-bold text-black">
        ag·gre·gate
        <br />/agrəˌgāt/
      </p>

      <p class="w-50 mx-auto text-center h6">
        Create a whole formed by combining several (typically fragmented)
        elements, thereby creating scale & reducing friction.
      </p>

      <p class="w-75 mx-auto text-center h6">
        The aggreagator tool helps you list all of your produce/harvest, inputs,
        warehouses, trucks etc on the market place.
        <br />Do sign up as either an aggregator, a farmers, a trader, an input
        provider, a trucker or a warehouse owner/manager.
      </p>
    </section>

    <section class="table-section px-3 mt-3">
      <div class="container-fluid px-0" style="min-width:100%">
        <AggregatorCarousel />
      </div>
    </section>

    <div class="d-flex justify-content-center text-center my-3">
      <router-link to="/login" class="btn btn-black btn-pill m-2"
        >Sign In</router-link
      >
      <router-link to="/signup" class="btn btn-black btn-pill m-2"
        >Sign Up</router-link
      >
    </div>
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import AggregatorCarousel from "@/components/AggregatorCarousel.vue";
export default {
  metaInfo: {
    title: "Quickleap",
    titleTemplate: "%s | Aggregator",
    htmlAttrs: {
      lang: "en",
      amp: true
    }
  },
  components: { Header, AggregatorCarousel },
  data() {
    return {
      forms: [
        {
          commmodity: "",
          qty: 1,
          total: 0,
          date: "2019-10-12",
          address: ""
        }
      ],

      items: [
        {
          value: "rice",
          name: "Rice",
          price: 1000
        },
        {
          value: "beans",
          name: "Beans",
          price: 2000
        },
        {
          value: "yam",
          name: "Yam",
          price: 3000
        }
      ]
    };
  }
};
</script>

<style lang="css">
.table-inventory th {
  background: linear-gradient(180deg, #ffffff 0%, rgba(255, 255, 255, 0) 100%),
    rgba(107, 113, 108, 0.55);
  padding: 15px 5px;
  color: black;
}
table.table.table-inventory td {
  padding: 22px 5px;
  text-align: center;
  vertical-align: middle;
}
</style>
